import styled from 'styled-components';

const StyledActionInner = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
  justify-content: center;
`;

export default StyledActionInner;
